import {
  Card,
  Container,
  useComputedColorScheme,
  useMantineTheme,
  Text,
  Button,
} from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import React, { useState } from "react";
import { useAppSelector } from "../../app/hooks";
import TravelAnimationSection from "./sections/TravelAnimationSection";
import Globe from "./sections/Globe";
import AlbumSlideshowExample from "./slideshow/AlbumSlideshowExample";

export default function AlbumDetail() {
  const profileState = useAppSelector((state) => state.profile);
  const [isEditing, setIsEditing] = useState(false);

  const theme = useMantineTheme();
  const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.xs})`);
  const colorScheme = useComputedColorScheme();

  if (isEditing) {
    return <div>Not implemented yet</div>;
  }

  return <AlbumSlideshowExample></AlbumSlideshowExample>;
}
